<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESS5UC3']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS5UC3']['20'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS5UC3']['30'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS5UC3']['40'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="desc_codcomp" name="desc_codcomp">{{ detail.tab1.codcomp }}{{ detail.tab1.desc_codcomp }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS5UC3']['50'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="desc_codpos" name="desc_codpos">{{ detail.tab1.desc_codpos }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS5UC3']['60'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="desc_codjob" name="desc_codjob">{{ detail.tab1.desc_codjob }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS5UC3']['70'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text txtarea-width width-100 margin-b-5" id="remarks" name="remarks">{{ detail.tab1.remarks }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS5UC3']['80'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="dtestart" name="dtestart">{{ setDateOutput(detail.tab1.dtestart) }}</div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESS5UC4']['0'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">

            <!-- <div class="row" align="right">
              <button class="btn bg-blue" data-toggle="modal" data-target="#hress5u-popup1" @click="callPopup('#hress5u-popup1')"><i class="fa fa-list-alt"></i> {{ labels['HRESS5UC5']['0'] }}</button>
              <button class="btn bg-blue" data-toggle="modal" data-target="#hress5u-popup2" @click="callPopup('#hress5u-popup2')"><i class="fa fa-list-alt"></i> {{ labels['HRESS5UP1']['0'] }}</button>
            </div>

            <br> -->
            <input data-toggle="modal" data-target="#hress5u-popup1" ref="popup1" type="hidden"/>
            <input data-toggle="modal" data-target="#hress5u-popup2" ref="popup2" type="hidden"/>

            <hrms-table :columns="tab2Table" :data="detail.tab2.table" :columnEvent="columnEvent" />

            <popup1 :labels="labels"
                    :nowLang="nowLang"
                    :popup1DetailTab2="popup1DetailTab2" />

            <popup2 :labels="labels"
                    :nowLang="nowLang"
                    :popup2DetailTab2="popup2DetailTab2"
                    :columnsDetailTab2Popup2Tab2="columnsDetailTab2Popup2Tab2" 
                    :columnsDetailTab2Popup2Tab3="columnsDetailTab2Popup2Tab3" 
                    :columnsDetailTab2Popup2Tab4="columnsDetailTab2Popup2Tab4" />          
                   
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import popup1 from 'components/hress5u/popup1'
import popup2 from 'components/hress5u/popup2'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hress5u-detail',
  props: [ 'labels', 'detail', 'nowLang', 'toggle', 'tab2Table', 'data', 'columnsDetailTab2Popup2Tab2', 'columnsDetailTab2Popup2Tab3', 'columnsDetailTab2Popup2Tab4', 'receivedHress5uDetailTab2Popup1', 'receivedHress5uDetailTab2Popup2', 'popup1DetailTab2', 'popup2DetailTab2', 'labelsButton' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    columnEvent (eventName, param) {
      let searchParams = {
        p_numreqst: param.numreqst,
        p_codpos: param.codpos,
        p_codjob: param.codjob
      }
      switch (eventName) {
        case 'quality':
          this.receivedHress5uDetailTab2Popup1(searchParams)
          this.$refs.popup1.click()
          break
        case 'jobDescription':
          this.receivedHress5uDetailTab2Popup2(searchParams)
          this.$refs.popup2.click()
          break
      }
    }
  },
  components: {
    popup1,
    popup2
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?16b7f15f